module.exports = __webpack_public_path__ + "static/media/Search Sanctions Entity Name.81602b60.xlsx";